export default {
    // 维修工单材料账单列表
   maintenanceMaterialShow:"/jobRequest/maintenanceMaterial/show",
    // 上传invoice
   MaterialUploadInvoice:"/jobRequest/maintenanceMaterial/uploadInvoice",
   // 展示Invoice
   MaterialShowInvoice:"/jobRequest/maintenanceMaterial/showInvoice",
    // 修改invoice
   MaterialUpdateInvoice:"/jobRequest/maintenanceMaterial/updateInvoice",
    // 在修改中新增invoice附件
   MaterialAddInvoiceFile:"/jobRequest/maintenanceMaterial/addInvoiceFile",
    // 在修改中删除invoice附件
   MaterialDeleteInvoiceFile:"/jobRequest/maintenanceMaterial/deleteInvoiceFile",
    // MaterialListAP 列表
   maintenancePayMaterialShow:"/jobRequest/maintenancePayMaterial/show",
    // MaterialListAP 添加vendor  glAcct
   maintenancePayMaterialAddGlAcctToInfo:"/jobRequest/maintenancePayMaterial/addGlAcctToInfo",
    // MaterialListAP 推送账单
   maintenancePayMaterialSendToVendorPayment:"/jobRequest/maintenancePayMaterial/sendToVendorPayment",
    // MaterialListAP mateialVendor下拉框
   materialVendorStoreVendor:"/settings/materialVendor/storeVendor",
};